export default __webpack_public_path__ + "static/media/toShow-1-min.35e7ae88.jpg";